import React, { useCallback, useState } from 'react';
import { Chip, styled, useTheme } from '@mui/material';
import { useCapTableContext } from 'context/CapTableContext';
import DisabledVariableChip from '../DisabledVariableChip';
import { VariableChipProps } from '../types';
import VariableChipStylesWrapper from '../VariableChipStylesWrapper';

interface StyledChipProps {
  isSelected: boolean;
}

const StyledChip = styled(Chip)<StyledChipProps>(({ theme, isSelected }) => ({
  fontSize: '0.775rem',
  zIndex: 2,
  padding: `${theme.spacing(0.25)}px 0`,
  marginRight: theme.spacing(2),
  fontWeight: 'bold',
  textTransform: 'uppercase',
  backgroundColor: isSelected ? theme.palette.primary.main : theme.palette.common.white,
  color: isSelected ? theme.palette.common.white : theme.palette.primary.main,
  '&:hover': {
    backgroundColor: isSelected ? theme.palette.primary.dark : theme.palette.grey[100],
  },
}));

const DividendRateVariableChip = () => {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  const { hasVariableDividendRate, setHasVariableDividendRate, hasVariableLiquidationPreference }
    = useCapTableContext();

  const handleClick = useCallback(() => {
    setHasVariableDividendRate(!hasVariableDividendRate);
  }, [setHasVariableDividendRate, hasVariableDividendRate]);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <VariableChipStylesWrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {(hasVariableDividendRate || isHovered) && !hasVariableLiquidationPreference && (
        <StyledChip
          label="Variable"
          clickable
          color="primary"
          size="small"
          onClick={handleClick}
          variant="outlined"
          isSelected={hasVariableDividendRate}
        />
      )}
      {hasVariableLiquidationPreference && isHovered && <DisabledVariableChip />}
    </VariableChipStylesWrapper>
  );
};

export default DividendRateVariableChip;
